import { Badge } from "reactstrap";
import { H3, Image, P } from "../AbstractElements";
import { Carousel } from "react-responsive-carousel";
import { dynamicImage } from "../Service/index";

export const Href = "#javascript";

// Header
export const Notification = "Notifications";
export const CheckAll = "Check all";
export const Messages = "Message";
export const Carts = "Cart";
export const OrderTotal = "Order Total";
export const GoToYourCart = "Go to your cart";
export const Checkout = "Checkout";
export const Bookmarks = "Bookmarks";
export const English = "English";
export const Deutsch = "Deutsch";
export const Español = "Español";
export const Français = "Français";
export const Português = "Português";
export const 简体中文 = "简体中文";
export const HelenWalter = "Helen Walter";
export const Admin = "Admin";
export const Back = "Back";
export const AddNewBookmark = "Add New Bookmark";

// Sidebar
export const Pinned = "Pinned";

// Dashboard
export const ShoppingPlaceDashboard = "Shopping place Dashboard";
export const Dashboard = "Dashboard";
export const Default = "Default";
export const TotalEarning = "Total Earning";
export const SinceLastMonth = "Since last month";
export const TotalSales = "Total Sales";
export const ThenLastWeek = "Then last Week";
export const TotalVisitors = "Total Visitors";
export const TopSellers = "Top Seller";
export const Trending = "Trending";
export const JailRoadSylhet = "jail Road,Sylhet";
export const VKEnterprise = "VK Enterprise";
export const SaleImproved = "Sale";
export const ProductSale = "Product Sale";
export const TopSellingProducts = "Top Selling Product";
export const BluetoothHandphone = "Bluetooth-Handphone";
export const Mamber = "Mamber";
export const WelltechHeadphoneBluetooth =
  "Welltech SH 12 Bluetooth Headphone Bluetooth";
export const Today = "Today";
export const TopCountrie = "Top Countries";
export const SalesSummarys = "Sales Summary";
export const RecentOrder = "Recent Order";
export const Invoices = "Invoice";
export const ActivityTimelines = "Activity Timeline";
export const TransactionHistorys = "Transaction History";
export const TopCustomers = "Top Customer";
export const SalesAnalyic = "Sales Analyic";
export const DealOpens = "Deal Open";
export const Customers = "Customer";
export const CRMDashboards = "CRM Dashboard";
export const BalanceOverviews = "Balance Overview";
export const Accpet = "Accpet";
export const Decline = "Decline";
export const AllNotifications = "All Notification (4)";
export const Dropdown = "Dropdown";
export const BestFlashSale = "Best Flash Sale";
export const SpecialOffer = "Special Offer";
export const WeekendSale = "Weekend Sale";

// Bonus UI
export const BadgeTitle = "Badge";
export const Scrollables = "Scrollable";
export const CustomScrollbar = "Custom Scrollbar";
export const SmallScrollText = "Solution for Business Transformation";
export const SmallSizeScrollbar = "Small Size Scrollbar";
export const BadgesScrollbar = "Badges Scrollbar";
export const ProfileScrollable = "Profile Scrollable";
export const ScrollableContents = "Scrollable Content";
export const HorizontalScrollbar = "Horizontal Scrollbar";
export const BothSideVisibleScrollbar = "Both Side Visible Scrollbar";
export const Scroll1 = (
  <>
    Inspiration can take many different forms, and{" "}
    <em className="txt-danger">professional growth never stops</em>
    . In light of this, we've compiled a comprehensive list of web design blogs
    that will keep your mind stimulated for the entire year. You won't find any
    stinkers on this list, so don't worry. We value your time and believe that
    you should only receive the greatest. Because of this, we've only gathered
    web design blogs that have recently being updated. Get ready to add numerous
    subscriptions by creating your Feebly account.
    <br />
    --&gt; Responsive...
    <br />
    --&gt; Secure your domain...
    <br />
    --&gt; Testing...
    <br />
    --&gt; Content creation...
    <br />
    --&gt; Visual elements...
    <br />
    --&gt; Launch...
  </>
);
export const Latesttrends = "Latest trends";
export const ThebestUXdesigner = "The best UX designer";
export const Bestwebsiteideas = "How to make best website ideas ";
export const Scroll3 = (
  <>
    <strong>1. Muzli </strong>
    <br />
    <strong>2. Facebook Design </strong>
    <br />
    <strong>3. Awwwards</strong>
    <br />
  </>
);
export const Scroll2 = (
  <>
    --&gt; Blog <br />
    --&gt; Portfolio website <br />
    --&gt; Event website <br />
    --&gt; personal website <br />
    --&gt; Fashion website <br />
    --&gt; Admin dashboards <br />
    --&gt; E-commerce website <br />
    --&gt; Beauty website <br />
    --&gt; Food website
    <br />
    --&gt; Animation website <br />
    --&gt; Financial website
  </>
);
export const TreeViews = "Tree View";
export const BasicTrees = "Basic Tree";
export const DisabledTrees = "Disabled Tree";
export const Toast = "Toasts";
export const LiveToasts = "Live Toast";
export const Toprighttoast = "Top-right toast";
export const ColorsScheme = "Colors Schemes";
export const StackingToast = "Stacking Toasts";
export const TranslucentToast = "Translucent Toasts";
export const DefaultToasts = "Default Toast";
export const UniqueToasts = "Unique Toast";
export const Bottomrighttoast = "Bottom-right toast";
export const BottomrighttoastDetails = "Your time over after 5 minute.";
export const Toplefttoast = "Top-left toast";
export const CionTheme = "Cion Theme";
export const Bottomlefttoast = "Bottom-left toast";
export const RemoveMyAccount = "Remove My Account";
export const ToastBody1 = "Your account will be permanently deleted?";
export const Kohotheme = "Koho theme";
export const Fastkarttheme = "Fastkart theme";
export const Oslotheme = "Oslo theme";
export const Voxotheme = "Voxo theme";
export const Roxotheme = "Roxo theme";
export const Zetatheme = "Zeta theme";
export const ToastPlacements = "Toast Placement";
export const ToastContent = (
  <>
    <em className="txt-danger">Attackers</em> on malicious activity may trick
    you into doing something dangrous like installing software or revealing your
    personal informations.
  </>
);
export const Ratings = "Rating";
export const Rating10 = "1/10 Rating";
export const RatingBars = "1 To 10 Rating Bar";
export const StarRatingBar = "Star Rating Bar";
export const ReversedRatingBar = "Reversed Rating Bar";
export const ThumbUpDownRate = "Thumb Up/Down Rating";
export const RatingWithTooltip = "Rating With Tooltip";
export const FontawesomeThumbsUpDownRating =
  "Fontawesome Thumbs Up/Down rating";
export const CurrentRatingBar = "Current Rating Bar";
export const WilliamEmail = "William@jourrapide.com";
export const January = "02 January 1988";
export const BOD = "BOD";
export const Dropzones = "Dropzone";
export const DefaultFileUpload = "Default File Upload";
export const ImagePreviews = "Image Preview";
export const SingleFileUploads = "Single File Upload";
export const MultiFileUploads = "Multi File Upload";
export const Tours = "Tour";
export const Selectposition = "Select a position...";
export const NewProducts = "New Product";
export const Name = "Name";
export const Code = "Code";
export const Price = "price";

// Ui-kits
export const Typographys = "Typography";
export const UiKits = "Ui Kits";
export const Heading = "Headings";
export const FontSize = "Font-Size";
export const Heading1 = "Heading 1 (MEGA)";
export const Heading2 = "Heading 2 (XL)";
export const Heading3 = "Heading 3 (LARGE)";
export const Heading4 = "Heading 4 (MEDIUM)";
export const Heading5 = "Heading 5 (SMALL)";
export const Heading6 = "Heading 6";
export const ColoredHeading = "Colored Headings";
export const SubHeading = " Sub Heading";
export const Fw700 = "f-w-700";
export const Fw600 = "f-w-600";
export const Fw500 = "f-w-500";
export const Fw400 = "f-w-400";
export const Fw300 = "f-w-300";
export const Unorder_list = "Unorder list";
export const Order_list = "Order list";
export const BonusUi = "Bonus Ui";
export const Animations = "Animations";
export const Typography = "Typography";
export const Avatar = "Avatars";
export const Grid = "Grid";
export const Tagpills = "Tag & pills";
export const Dropdowns = "Dropdown";
export const Tabs = "Tabs";
export const Accordion = "Accordion";
export const Display = "Display";
export const Displayheadings = "display heading";
export const Displayheading = "Display heading";
export const Additive_Border = "Additive Border";
export const Subtractive_Border = "Subtractive Border";
export const Additive_Radius = "Additive Radius";
export const CustomBorder_radius = "Custom Border-radius Class";
export const Border_Color = "Border Color";
export const Border_Width = "Border-Width";
export const Text_Colors = "Text Colors";
export const Dark_Background = "Dark Background";
export const Light_Backgrounds = "Light Backgrounds";
export const Light_Background = "Light Background";
export const Extended_Background = "Extended Background Colors";
export const Light_card = ".light-card";
export const Inlinetextelements = "Inline text elements";
export const Sizes = "Sizes";
export const StatusIndicator = "Status Indicator";
export const Shapes = "Shapes";
export const Ratio = "Ratio";
export const Grouping = "Grouping";
export const HelpersClasses = "Helper Classes";
export const StylesInBorders = "Styles In Borders";
export const BordersAndDisplays = "Borders And Displays";
export const BackgroundColors = "Background Colors";
export const TextColor = "Text Colors";
export const FontsSizes = "Font Sizes";
export const Grids = "Grid";
export const Gridbehavior = "Grid behavior";
export const Horizontaltimes = "Horizontal at all times";
export const Collapsedtostart =
  "Collapsed to start, horizontal above breakpoints";
export const Maxcontainerwidth = "Max container width";
export const None = "None (auto)";
export const Px540 = "540px";
export const Px720 = "720px";
export const Px960 = "960px";
export const Px1140 = "1140px";
export const Px1320 = "1320px";
export const Classprefix = "Class prefix";
export const Cols = ".col-";
export const Colsm = ".col-sm-";
export const Colmd = ".col-md-";
export const Collg = ".col-lg-";
export const Colxl = ".col-xl-";
export const Colxxl = ".col-xxl-";
export const Ofcolumns = "# of columns";
export const Gutterwidth = "Gutter width";
export const Gutterwidthno = "1.5rem (.75rem on left and right)";
export const Nestable = "Nestable";
export const Yes = "Yes";
export const Offsets = "Offsets";
export const Columnordering = "Column ordering";
export const Onecolumns = "one column";
export const Onecolumn = "One column";
export const Twocolumns = "two column";
export const Twocolumn = "Two column";
export const GridOption = "Grid Options";
export const GridForColumn = "Grid For Column";
export const Class = "Class";
export const Valueclass = "Value of the class";
export const Verticalclass = ".align-items-*";
export const VerticalPosition = " start / center / end / baseline / stretch";
export const HorizontalClass = ".justify-content-*";
export const HorizontalPosition = "start / ce end / around / between";
export const Level1col3 = "Level 1: .col-3";
export const Level2col5 = "Level 2: .col-5";
export const Level2col7 = "Level 2: .col-7";
export const Level1col2 = "Level 1: .col-2";
export const Level1col10 = "Level 1: .col-10";
export const Level2col4 = "Level 2: .col-4";
export const Orders = "Order";
export const OrderClass = ".order-*";
export const OrderPosition = " first / 2 / 3 / 4 / 5 / last";
export const OffsetClass = ".offset-*";
export const OffsetStep = " 1 / 2 / ... / 11 / 12";
export const HorizontalAlignments = "Horizontal Alignment";
export const Nestings = "Nesting";
export const VerticalAlignments = "Vertical Alignment";
export const ImagesSizes = "Images Sizes";
export const BorderColor = "Border Color";
export const Blockquotes = "Blockquotes";
export const ListingTypographys = "Listing Typography";
export const TextColors = "Text Color";
export const FontWeights = "Font Weight";
export const BadgesContextual = "Badges Contextual Variations";
export const PillsVariations = "Pills Contextual Variations";
export const NumberofBadge = "Number of Badge";
export const NumberofPills = "Number of Pills Tags";
export const BadgeIcons = "Badge Tags With Icons";
export const PillsWithIcons = "Rounded Pills With Icons";
export const BadgeHeadingsExample = "Badge Headings Example";
export const BadgeHeadings = "Badge Heading";
export const Latest = "Latest";
export const Logout = "Logout";
export const BadgesPartButtons = "Badges As Part Buttons";
export const Login = "Log in";
export const Inbox = "Inbox";
export const Primary = "Primary";
export const Message = "Messages";
export const Charts = "Chart";
export const MonthlyHistorys = "Monthly History";
export const SkillStatuss = "Skill Status";
export const OrdersStatus = "Order Status";
export const LiveProduct = "Live Products";
export const TurnOver = "Turn over";
export const CryptoAnnotation = "Crypto Annotations";
export const CryptocurrencyPrice = "Cryptocurrency Prices";
export const StockMarkets = "Stock Market";
export const Finances = "Finance";
export const MonthlySale = "Monthly Sales";
export const Uses = "Uses";
export const BasicProgressBars = "Basic Progress Bars";
export const ProgressStriped = "Progress Bars Striped";
export const Progressanimated = "Progress Bars animated";
export const Simple = "Simple";
export const Upto = "Up to ";
export const SimpleText = ", Hurry Up Online Shopping";
export const ExploreMore = "Explore More";
export const Close = "Close";
export const SaveChanges = "Save Changes";
export const Scrollingcontent = "Scrolling content";
export const WedDesigner = "Wed Designer";
export const Multiplebars = "Multiple bars";
export const ProgressWithNumberSteps = "Progress With Number Steps";
export const CustomProgressBars = "Custom Progress Bars";
export const SmallProgressBars = "Small Progress Bars";
export const LargeProgressBars = "Large Progress Bars";
export const CustomHeightProgressBars = "Custom Height Progress Bars";
export const Alerts = "Alert";
export const LinkColorInDarkTheme = "Link Color In Dark Theme";
export const PrimaryAlert = "Primary Alert";
export const PrimaryLightAlert = "Primary Light Alert";
export const LinkColorInLightTheme = "Link Color In Light Theme";
export const OutlineDarkAndLightAlerts = "Outline Dark And Light Alerts";
export const AlertsWithIconsandTextActions =
  "Alerts With Icons and Text Actions";
export const Check = "Check";
export const Showlivealert = "Show live alert";
export const DismissingDarkAlerts = "Dismissing Dark Alerts";
export const DismissingLightAlerts = "Dismissing Light Alerts";
export const LiveAlerts = "Live Alert";
export const LeftBorderAlerts = "Left Border Alert";
export const AdditionalContent = "Additional content";
export const Modals = "Modal";
export const BasicModals = "Basic Modal";
export const Tooltipspopovers = "Tooltips and popovers";
export const Popovermodal = "Popover in a modal";
export const This = "This ";
export const TriggerText = " triggers a popover on click.";
export const Thislink = "This link";
export const And = "and";
export const Thatlink = "that link";
export const HoverText = " have tooltips on hover.";
export const Tooltipsmodal = "Tooltips in a modal";
export const OpenmodalforCion = "Open modal for Cion";
export const HurryUp = "Hurry Up!";
export const CionSIGNUP = "CION SIGN-UP";
export const FirstName = "First name";
export const Lastname = "Last name";
export const Checktext =
  "You accept our Terms and Privacy Policy by clicking Submit below.";
export const TooltipButtontext = "this is amazing content";
export const SignUp = "Sign Up";
export const Looksgood = "Looks good!";
export const SizesModals = "Sizes Modal";
export const FullScreenModal = "Full Screen Modal";
export const Fullscreenmodal = "Fullscreen modal";
export const ExtraLargeModal = "Extra large Modal";
export const Large_Modal = "large Modal";
export const Small_Modal = "Small Modal";
export const Startyourgoals = "Start with your goals";
export const WebDesign = "Web Design";
export const Fullscreenbelow_sm = "Fullscreen below sm";
export const Fullscreenbelow_md = "Fullscreen below md";
export const Fullscreenbelow_lg = "Fullscreen below lg";
export const Fullscreenbelow_xl = "Fullscreen below xl";
export const Fullscreenbelow_xxl = "Fullscreen below xxl";
export const Verticallycentered = "Vertically centered";
export const CenteredError = "Ohh! Something went wrong!";
export const Openfirstmodal = "Open first modal";
export const RemoveaccountText =
  "Remove your complete account from your phone or tablet to sign out of the Gmail app.";
export const Connectnewaccount = "Connect new account";
export const Cancel = "Cancel";
export const Notamember = " Not a member?";
export const Register = "Register";
export const YesLogout = "Yes, Log out";
export const LogoutText = "Are you sure want to logout this dashboard?";
export const Alreadyleaving = "Already leaving??";
export const Staticbackdropmodal = "Static backdrop modal";
export const FullscreenModals = "Fullscreen Modal";
export const CenteredModals = "Centered Modal";
export const ToggleBetweenModals = "Toggle Between Modals";
export const StaticBackdropModal = "Static Backdrop Modal";
export const CionLogin = "Cion Login";
export const Email = "Email";
export const Password = "Password";
export const Checkmeout = "Check me out";
export const Signin = "Sign in";
export const ClickOut = "Click Out";
export const CionCustomModals = "Cion Custom Modals";
export const Modal_1 = "Modal 1 - ";
export const Modal_2 = "Modal 2 - ";
export const Modal_3 = "Modal 3 - ";
export const ResultModal = "Result Modal";
export const WilliamJennings = "William C. Jennings";
export const ContactUs = "Contact Us";
export const Contactno = "US 310-273-0666";
export const LibbyStreet = "4377 Libby Street Beverly Hills";
export const Follower = "Follower";
export const Following = "Following";
export const Jan25 = "25 Jan";
export const Minread6 = "6 min read";
export const min3ago = "3 min ago";
export const min1read = "1 min read";
export const hours10ago = "10 hours ago";
export const ProfileHead2 =
  "Wonderful piece that successfully conveys the magnificence of the mountains and the natural world.";
export const ProfileHead2Text = (
  <>
    English Romantic painter, printer, and watercolourist{" "}
    <em className="txt-danger">William C. Jennings</em>{" "}
    {
      "Is most renowned for his expressive colorization, creative landscapes, and stormy, sometimes violent maritime works. However, this moody image of the Devil's Bridge in Switzerland, close to the Gotthard Pass, feels incredibly authentic and accurately depicts historical occasions when Russian general Suvorov crossed the Alps and fought not only far larger enemy troops!"
    }
  </>
);

export const ProfileText2 = (
  <>
    {
      "The curved canvas is enclosed in a complex frame that the artist created but that his buddy Gottlieb Christian Kuhn carved. A variety of Christian symbols are depicted on the frame, including the faces of five infant angels, a star, grapes, vines, corn, and God's eye.Many of the Romantic elements and subjects that he would explore throughout his career are present in this work, one of his earliest, most notable of which is the landscape's significant significance. In spite of the altarpiece's inclusion of a crucifix, the emphasis is"
    }
    <a className="txt-danger" href="user-profile.html" target="_blank">
      {" "}
      Read More
    </a>
  </>
);
export const Location = "Location";
export const Dec09 = "09 Dec";
export const Min2read = "2 min read";
export const Clickit = "Click it!";
export const Surprise = "Surprise!";
export const Informational = "Informational";
export const Warning = "Warning";
export const Pikachu = "Pikachu";
export const Questionsstate = "Questions state";
export const Username = "Username";
export const Loginsuccessfully = "Login successfully";
export const Dangermode = "Danger mode";
export const Alertmode = "Alert mode";
export const Timer = "Timer";
export const Moviemode = "Movie mode";
export const Copytext = "Copy text";
export const Breadcrumbs = "Breadcrumb";
export const DefaultBreadcrumbs = "Default Breadcrumb";
export const UIKits = "UI Kits";
export const Alert = "Alert";
export const DividerBreadcrumb = "Divider Breadcrumb";
export const Progress = "Progress";
export const WithIconsBreadcrumb = "With Icons Breadcrumb";
export const VariationOfBreadcrumb = "Variation Of Breadcrumb";
export const Homegt = "Home ->";
export const Tablesgt = "Tables ->";
export const Bootstrapgt = "Bootstrap Tables ->";
export const BasicTables = "Basic Tables";
export const ColoredBreadcrumb = "Colored Breadcrumb";
export const Flag_icon = "Flag-icon";
export const Gallery = "Gallery";
export const Gallery_grid = "Gallery-grid";
export const RangeSliders = "Range Slider";
export const BasicSlider = "Basic Slider";
export const NegativeValues = "Negative Values";
export const Disabled = "Disabled";
export const FormatedLabel = "Formated Label";
export const DraggableRange = "Draggable Range";
export const ImageCroppers = "Image Cropper";
export const BasicCards = "Basic Card";
export const BasicCardText = (
  <>
    Tabs have long been used to show alternative views of the same group of
    information tabs in software. Known as
    <em className="txt-danger">“module tabs”</em> , these are still used today
    in web sites. For instance, airline companies such as Ryanair, easyJet and
    AirMalta use module tabs to enable the user to switch between bookings for
    flights, hotels and car hire.
  </>
);
export const FlatCards = "Flat Card";
export const FlatCardText = (
  <>
    A navigation bar is a particularly important feature because it allows
    visitors to quickly and easily find
    <em className="txt-danger"> important pages on your website</em> , like your
    blog, product pages, pricing, contact info, and documentation. This improves
    the chances of visitors browsing your site longer, which can boost your page
    views and reduce your bounce rate.
  </>
);
export const WithoutshadowCard = "Without shadow Card";
export const ShadowCardText = (
  <>
    {" "}
    <strong>Visit Us: </strong> 2600 Hollywood Blvd,Florida, United States-
    33020
    <br />
    <strong>Mail Us:</strong>contact@us@gmail.com
    <br />
    <strong>Contact Number: </strong>(954) 357-7760
  </>
);
export const IconInHeading = " Icon In Heading";
export const IconHeadtext = (
  <>
    Use the any icons for heading. <code>[font-awesome/ico-font/feather]</code>.
  </>
);
export const IconHeadtext2 = (
  <>
    <P className="mb-xl-0 mb-sm-4">
      We provide end to end digital solutions, right from designing your
      website/application development: Domain, Web Hosting, Email Hosting
      Registration, Search Engine Optimization and other Internet Marketing,
      Renewal of Services timely and effectively.
    </P>
  </>
);
export const DarkColorCard = "Dark Color Card";
export const DarkHeadtext = (
  <>
    Use the <code>.bg-dark </code>color for dark background card.
  </>
);
export const DarkBodytext = (
  <>
    <P>
      {" "}
      <em className="txt-danger fw-bold">Smart headphones</em> — also called
      smart earbuds or hearable — are high-tech in-ear devices that do more than
      transmit audio. These headphones are usually wireless, and they can sync
      up with your phone, tablet, computer or other Bluetooth-enabled device.
      The main appeal of hearables is convenience, as they allow you to complete
      common tasks without directly accessing your phone or computer. Smart
      wireless headphones sync up to other devices using Bluetooth technology,
      and many of their features rely on data from your smartphone or computer.
    </P>
  </>
);
export const Card_Footer = "Card Footer";
export const InfoColorHeader = "Info Color Header";
export const InfoHeadText =
  "By following instructions and adding your own unique twist and style, you may apply your imagination as a web designer. The majority of the tasks you'll be assigned will have a specific due date and work description, but the reason you were employed was because they need a specialist to inject some much-needed creativity.";
export const CubaTheme = "Cuba Theme";
export const InfoColorBody = "Info Color Body";
export const InfoBodyText =
  'It is the responsibility of the UX designer to make a product or service useful, pleasurable, and accessible. The word "user experience" is used by various industries, although it is most frequently related to digital design for websites and mobile applications.There is no need for coding in user experience design.';
export const InfoFooter = "Info Color Footer";
export const WebDeveloper = "Web Developer";
export const FooterInfotext =
  "A programmer who uses the client-server architecture to create World Wide Web applications is known as a web developer. The apps generally employ any general-purpose programming language on the server and HTML, CSS, and JavaScript on the client.";
export const UXDesigner = "UX Designer";
export const Oneof = "One of ";
export const InfoColorBodys = "Info Color Body";
export const CreativeCards = "Creative Card";
export const BorderLefts = "Border Left";
export const BorderleftText =
  "Us Technology offers web & mobile development solutions for all industry verticals.Include a short form using fields that'll help your business understand who's contacting them.";
export const VisitUs = "Visit Us:";
export const MailUs = "Mail Us:";
export const ContactNumber = "Contact Number:";
export const BorderRights = "Border Right";
export const BorderRightText =
  "Us Technology offers web & mobile development solutions for all industry verticals.Include a short form using fields that'll help your business understand who's contacting them. ";
export const BorderTopText = (
  <>
    Tabs have long been used to show alternative views of the same group of
    information tabs in software. Known as
    <em className="txt-danger">“module tabs”</em> , these are still used today
    in web sites. For instance, airline companies such as Ryanair, easyJet and
    AirMalta use module tabs to enable the user to switch between bookings for
    flights, hotels and car hire.
  </>
);
export const Emailaddress = "Email address";
export const BorderTops = "Border Top";
export const BorderBottoms = "Border Bottom";
export const BorderBottomText = (
  <>
    A navigation bar is a particularly important feature because it allows
    visitors to quickly and easily find
    <em className="txt-danger"> important pages on your website</em> , like your
    blog, product pages, pricing, contact info, and documentation. This improves
    the chances of visitors browsing your site longer, which can boost your page
    views and reduce your bounce rate.
  </>
);
export const SimpleAccordionText = (
  <P>
    {" "}
    Web design<em className="txt-danger"> identifies the goals</em> of a website
    or webpage and promotes accessibility for all potential users. This process
    involves organizing content and images across a series of pages and
    integrating applications and other interactive elements{" "}
  </P>
);
export const SimpleAccordionText1 = (
  <P>
    {" "}
    <strong> Search engine optimization: </strong> Search engine optimization
    (SEO) is a method for improving the chances for a website to be found by
    search engines. Web design codes information in a way that search engines
    can read it. It can boost business because the site shows up on the top
    search result pages, helping people to find it.
    <br />
    <br />
    <strong> Mobile responsiveness:</strong> Mobile responsiveness is the
    feature of a website that allows it to display on a mobile device and adapt
    its layout and proportions to be legible. Web design ensures sites are easy
    to view and navigate from mobile devices. When a website is well-designed
    and mobile-responsive, customers can reach the business with ease.
    <br />
    <br />
    <strong> Improved sales:</strong>Increasing the number of items sold or
    acquiring more active customers are objectives of a compelling website. As
    web design reaches targeted customers and search engines, it helps the
    business make conversions on their site and improve its sales.
  </P>
);
export const SimpleAccordionText2 = (
  <P>
    {" "}
    The web design process allows designers to adjust to any preferences and
    provide effective solutions. There are many standard components of every web
    design, including:
    <br />
    --&gt; Layout
    <br />
    --&gt; Images
    <br />
    --&gt; Visual hierarchy
    <br />
    --&gt; Color scheme
    <br />
    --&gt; Typography
    <br />
    --&gt; Navigation
    <br />
    --&gt; Readability
    <br />
    --&gt; Content
  </P>
);
export const BorderPrimaryState = "Border Primary State";
export const TeresaMosteller = "Teresa J. Mosteller";
export const GloriaAcheson = "Gloria D. Acheson";
export const BryanOwens = "Bryan A. Owens";
export const BorderWarningState = "Border Warning State";
export const BorderWarningtext =
  "known for delivery of useful and usable solutions";
export const BorderWarningtext1 = "Solve your problem with us";
export const BorderWarningtext2 = "Certified Professionals";
export const BorderWarningtext3 = "Growth-Driven ";
export const BorderSecondaryState = "Border Secondary State";
export const StellaNowland = "Stella Nowland ";
export const LolaStanford = "Lola Stanford ";
export const CaitlinCoungeau = "Caitlin Coungeau ";
export const GracielaMcClaran = "Graciela McClaran ";
export const Freelance = "Freelance ";
export const Issue = "Issue ";
export const Social = "Social ";
export const AbsoluteCard = "Absolute Card";
export const AbsolutePrimarytext =
  "We provide end to end digital solutions, right from designing your website/application development: Domain, Web Hosting, Email Hosting Registration, Search Engine Optimization and other Internet Marketing, Renewal of Services timely and effectively.";
export const AbsoluteSecondarytext =
  "When someone visits your homepage, your design should inspire them to stay. Therefore, your value proposition should be established on the homepage for visitors to select to stay on your website.Building trust, expressing value,to the next step all depend on a page's design.";
export const TimeLines = "TimeLine";
export const BasicTimeline = "Basic Timeline";
export const HoveringTimeline = "Hovering Timeline";
export const Hover1text = "January 2022- Annual Function";
export const Hover1text2 = "Largo Febo,10225012-Calvisano BS";
export const Locationtext =
  "What a dynamic performance by the eighth-grade students, Let's welcome the ninth-grade kid to the stage.";
export const MollyBoake = "Molly Boake";
export const Mollymail = "MollyBoake@rhyta.com";
export const Ofwrrior = "Ofwrrior Company";
export const FresherTime = "March 2022 - Fresher Interview";
export const USMeeting = "US Meeting";
export const LillianGoodfellow = "Lillian J. Goodfellow";
export const CarolynSutton = "Carolyn A. Sutton";
export const UpdatedProduct = "Updated Product";
export const Updatetext = "Quisque a consequat ante sit amet magna...";
export const AddedBewItems = "Added Bew Items";
export const Afresher = "A fresher's interview is to be conducted";
export const VariationTimelines = "Variation Timeline";
export const Tellojust = "Tello just like your product";
export const HorizontalTimelines = "Horizontal Timeline";
export const Conference_util = "Conference";
export const Meeting_util = "Meeting";
export const Readmore = "Read more";
export const Meet_up = "Meet-up";
export const Launch_Theme = "Launch Theme";
export const TimeLineData1 = (
  <div className="cd-timeline-content">
    <div className="timeline-wrapper">
      <Badge color="warning">app-ideas</Badge>
    </div>
    <H3 className="m-0">Established new the app-ideas repository.</H3>
    <P className="mb-0">
      developers who are just beginning their learning process. those who often
      concentrate on developing programmes with a user interface.
    </P>
    <div className="time-content pt-2">
      <i className="icon-github" />
      <H3>View it on Github</H3>
    </div>
  </div>
);

export const TimeLineData2 = (
  <div className="cd-timeline-content">
    <div className="timeline-wrapper">
      <Badge color="danger">Blog</Badge>
    </div>
    <H3 className="m-0">Implemented the program for weekly code challenges.</H3>
    <P className="mb-0">
      Challenges{" "}
      <em className="txt-danger">
        help you build problem-solving skills, better understand the
        programming.{" "}
      </em>
      If you want to improve your skills in programming.{" "}
    </P>
    <div className="ratio ratio-21x9 m-t-20">
      <iframe
        src="https://www.youtube.com/embed/sqRk0Ly66Ps"
        allowFullScreen
        title="abc"
      />
    </div>
  </div>
);
export const TimeLineData3 = (
  <div className="cd-timeline-content">
    <div className="timeline-wrapper">
      <Badge color="info">Designer</Badge>
    </div>
    <H3 className="m-0">Research about most recent design trends.</H3>
    <P className="mb-0">Spend some time looking up current design trend.</P>
    <Carousel>
      <div>
        <Image
          className="d-block w-100"
          src={dynamicImage("banner/1.jpg")}
          alt="office-work"
        />
      </div>
      <div>
        <Image
          className="d-block w-100"
          src={dynamicImage("banner/2.jpg")}
          alt="office-work"
        />
      </div>
      <div>
        <Image
          className="d-block w-100"
          src={dynamicImage("banner/3.jpg")}
          alt="office-work"
        />
      </div>
    </Carousel>
  </div>
);

export const TimeLineData4 = (
  <div className="cd-timeline-content">
    <div className="timeline-wrapper">
      <Badge color="primary">Audio testing</Badge>
    </div>
    <H3 className="m-0">Musical trends and predictability</H3>
    <P className="mb-0">
      So, the next time you listen to music, you might or might not consider how
      it's actively altering your mood.
    </P>
    <audio controls>
      <source src="../assets/audio/horse.ogg" type="audio/ogg" />
    </audio>
  </div>
);
export const TimeLineData5 = (
  <div className="cd-timeline-content">
    <div className="timeline-wrapper">
      <Badge color="success">Meet-up</Badge>
    </div>
    <H3 className="m-0">{"Web-designer's meet-up"}</H3>
    <P className="mb-0">
      {" "}
      {
        "Find nearby web designers to network with! A Web Design Meetup is a place where you can discuss tools."
      }
    </P>
    <div className="time-content pt-2">
      <i className="icon-android" />
      <H3>Please! Meet-up</H3>
    </div>
  </div>
);
export const TimeLineData6 = (
  <div className="cd-timeline-content">
    <div className="timeline-wrapper">
      <Badge color="warning">Resolutions</Badge>
    </div>
    <H3 className="m-0">My Resolutions for 2023</H3>
    <P className="mb-0">
      {
        "I'm determined to streamline, organism, systematism, realign, and embrace life in 2023."
      }
    </P>
    <div className="time-content pt-2">
      <i className="icon-write" />
      <H3>My Resolutions</H3>
    </div>
  </div>
);
export const OwlCarousels = "Owl Carousel";
export const SlidesOnly = "Slides Only";
export const WithControls = "With Controls";
export const AutoPlayVariant = "Auto Play Variant";
export const WithIndicators = "With Indicators";
export const IndividualCarousels = "Individual Carousel-Item Interval";
export const VerticalCarousels = "Vertical Carousel";
export const WithCaptions = "With Captions";
export const CenterSlides = "Center Slide";
export const SweetAlerts = "Sweet Alert";
export const BasicExample = "Basic Example";
export const TitleWithATextUnder = "Title With A Text Under";
export const InfoAlerts = "Info Alert";
export const WarningAlerts = "Warning Alert";
export const PikachuAlert = "Pikachu Alert";
export const QuestionsAlert = "Questions Alert";
export const UsernameAlert = "Username Alert";
export const SuccessMessages = "Success Message";
export const DangerAlerts = "Danger Alert";
export const WarningModal = "Warning Modal";
export const AutoCloseTimer = "Auto Close Timer";
export const AJAXRequestMovie = "AJAX Request Movie";
export const Ribbon = "Ribbons";
export const VariationsOfLeftRibbons = "Variations Of Left Ribbons";
export const VariationsOfRightRibbons = "Variations Of Right Ribbons";
export const Pagination = "Paginations";
export const DefaultPaginations = "Default Pagination";
export const PaginationWithActiveAndDisabled =
  "Pagination With Active And Disabled";
export const PaginationWithIcons = "Pagination With Icons";
export const RoundedPaginations = "Rounded Pagination";
export const PaginationAlignment = "Pagination Alignment";
export const PaginationSizing = "Pagination Sizing";
export const ProfileModal = "Profile Modal";
export const BalanceModal = "Balance Modal";
export const ResultText = "Example of Cion login form.";
export const BrooklynSimmons = "Brooklyn Simmons";
export const Brooklysimmons = "@brookly.simmons";
export const YourBalance = "Your Balance";
export const YourTotalBalance = "768,987.90";
export const Cash_Back = "Cash Back";
export const Investment_Constant = "Investment";
export const Popoverontop = "Popover on top";
export const Popovers = "Popover";
export const BasicPopover = "Basic Popover";
export const Popovertitle = "Popover title";
export const HoverPopover = "Hover Popover";
export const Hovertooltip = "Hover tooltip";
export const Dismissiblepopover = "Dismissible popover";
export const PopoverDirections = "Popover Direction";
export const PopoverOnTop = "Popover On Top";
export const PopoverOffset = "Popover Offset";
export const Popoveroffset = "Popover offset 50";
export const Popoversoffset = "Popover offset -50";
export const PopoverOnLeft = "Popover On Left";
export const Tooltips = "Tooltip";
export const BasicTooltips = "Basic Tooltip";
export const BasicTooltipText = "It's magic please hover me... ";
export const SurpriseText = "Surprise!!! Thank you for hovering...";
export const InlineTooltipContent = "Inline Tooltip Content";
export const Toolstip = "tooltip";
export const ColoredTooltips = "Colored Tooltip";
export const TooltipDirections = "Tooltip Directions";
export const Tooltipontop = "Tooltip on top";
export const HTMLElementsWithHoverEffect = "HTML Elements With Hover Effect";
export const NotificationsReceived = "Notifications Received";
export const FilledTooltip = "Filled Tooltip";
export const TooltipPrimary = "Tooltip Primary";
export const HtmlTooltipData2 = "<b>Thank</b> <em>you</em>";
export const HtmlTooltipData3 = "<em>Thank</em> <u>you</u>";
export const HtmlTooltipData4 = "<b>Thank</b> <em>you</em>";
export const BasicDropdowns = "Basic Dropdown";
export const Project = "Project";
export const ProjectProgress = "Project Progress";
export const ProjectProgressPlaceholder = "Enter project Progress";
export const Ecommerce = "Ecommerce";
export const Crypto = "Crypto";
export const RoundedDropdowns = "Rounded Dropdown";
export const Dark = "Dark";
export const Light = "Light";
export const Lighter = "Lighter";
export const General = "General";
export const Chart = "Chart";
export const Party = "Party";
export const PartyList = "Party List";
export const Balloons = "Balloons";
export const SplitDropdowns = "Split Dropdown";
export const HeadingDropdowns = "Heading Dropdown";
export const Cake = "Cake";
export const WithInputType = "With Input Type";
export const Defaultcheckbox = "Default checkbox";
export const Defaultradio = "Default radio";
export const DarkNight = "Dark Night";
export const Darkmoon = "Dark moon";
export const Darkowl = "Dark owl";
export const Nightfall = "Nightfall";
export const Dropdownform = "Dropdown form";
export const Rememberme = "Remember me";
export const Text = "Text";
export const Hourly = "Hourly";
export const FixPrice = "Fix price";
export const Textleft = "Text-left";
export const Priority = "Priority";
export const PriorityPlaceholder = "Select Status";
export const Low = "Low";
export const ProjectSizePlaceholder = "Select Issues";
export const High = "High";
export const EndingDate = "Ending date";
export const Urgent = "Urgent";
export const Hello = "Hello..";
export const Howareyou = "How are you?";
export const Whatareyou = "What are you doing?";
export const Warningtop = "Warning top";
export const Becareful = "Be careful ";
export const Notifications = "Notifications";
export const Beware = "Beware ";
export const Largebutton = "Large button";
export const Smallbutton = "Small button";
export const Mediumbutton = "Medium button";
export const VeryLargebutton = "Very Large button";
export const VerySmallbutton = "Very Small button";
export const ExtraSmallbutton = "Extra Small button";
export const Extraextrasmall = "Extra Extra small";
export const DarkDropdowns = "Dark Dropdown";
export const UniqueDropdowns = "Unique Dropdown";
export const JustifyContents = "Justify Contents";
export const Alignments = "Alignments";
export const HelperCards = "Helper Card";
export const DividerDropdowns = "Divider Dropdown";
export const DropdownSizings = "Dropdown Sizing";
export const Accordions = "Accordion";
export const UploadProjectFiles = "Upload project file";
export const DropFilesHereOrClickToUpload =
  "Drop files here or click to upload.";
export const DropFileUploadText =
  "(This is just a demo dropzone. Selected files are ";
export const ActualFileUpload = " actually uploaded.)";
export const SimpleAccordions = "Simple Accordion";
export const Webdesignersdo = "What do web designers do?";
export const Usewebdesign = "What is the use of web design?";
export const Elementswebdesign = "What are the elements of web design?";
export const FlushAccordions = "Flush Accordion";
export const MultipleCollapseAccordion = "Multiple Collapse Accordion";
export const Togglefirst = "Toggle first element";
export const Togglesecond = "Toggle second element";
export const Toggleboth = "Toggle both elements";
export const Togglewidthcollapse = "Toggle width collapse";
export const Linkwithhref = "Link with event";
export const ButtonwithEvent = "Button with event";
export const WithIconsAccordion = "With Icons Accordion";
export const OutlineAccordions = "Outline Accordion";
export const HorizontalAccordions = "Horizontal Accordion";
export const CollapseAccordions = "Collapse Accordion";
export const BootstrapTabs = "Bootstrap Tabs";
export const Simpletabs = "Simple tabs";
export const Profile = "Profile";
export const Tables = "Tables";
export const Contact = "Contact";
export const Home = "Home";
export const IconsWithTabs = "Icons With Tabs";
export const VerticalTabs = "Vertical Tabs";
export const Components = "Components";
export const Settings = "Settings";
export const Pages = "Pages";
export const Aboutus = "About us";
export const Contactus = "Contact us";
export const Blog = "Blog";
export const Pillstabs = "Pills tabs";
export const JustifyTabs = "Justify Tabs";
export const CionProfile = "CION Profiles For New Employees:";
export const Webdesigner = "Web designer";
export const WebDesigner = "Web Designer";
export const UXdesigner = "UX designer";
export const IOTdeveloper = "IOT developer";
export const MaterialStyleLeftTabs = "Material Style Left Tabs";
export const MaterialStyleTabs = "Material Style Tabs";
export const User = "User";
export const Description = "Description";
export const Review = "Review";
export const LogoDesign = "Logo Design";
export const Web_Design = "Web Design & Development ";
export const ECommerce = "E-Commerce";
export const SEO = "SEO";
export const WowAnimations = "Wow Animations";
export const ApexCharts = "Apex Charts";
export const StarterKits = "Starter Kits";
export const PRODUCT = "PRODUCT";
export const PRODUCTDETAILS = "PRODUCT DETAILS ";
export const CART = "CART ";
export const CHECKOUT = "CHECKOUT";
export const BorderTab = "Border Tabs";

// MISCELLANEOUS
export const SamplePages = "Sample Page";
export const GalleryGrids = "Gallery Grid";
export const IMAGEGALLERY = "IMAGE GALLERY";
export const GalleryGridWithDescriptions = "Gallery Grid With Description";
export const IMAGEGALLERYWITHDESCRIPTION = "IMAGE GALLERY WITH DESCRIPTION";
export const MasonryGallerys = "Masonry Gallery";
export const MasonryGalleryWithDescriptions =
  "Masonry Gallery With Description";
export const PortfolioTitle = "Portfolio Title";
export const ImageHoverEffect = "Image Hover Effects";
export const HoverEffect = "Hover Effects";
export const BlogDetail = "Blog Details";
export const MarkJecnoBlog =
  "People just dont do it anymore. We have to change that. Sometimes the simplest things are the most profound.";
export const BlogSingles = "Blog Single";
export const SingleBlogHeading =
  "The Harpeth rises in the westernmost part of Rutherford County, just to the east of the community of College Grove in eastern Williamson County. Internet.";
export const AddPosts = "Add Post";
export const PostEdits = "Post Edit";
export const Category = "Category";
export const Content = "Content";
export const BlogPostText = `Enter text in the area on the left. For more info, click the ? (help) icon in the menu.`;
export const FAQHeading = "FAQ";
export const QuickQuestions = "Quick Questions are answered";
export const SearchArticles = "SearchArticles";
export const LatestUpdates = "Latest Updates";
export const SeeAll = "See All";
export const AskQuestion = "Ask Question";
export const Navigation = "Navigation";
export const AskOurCommunity = "Ask our community";
export const FeaturedTutorials = "Featured Tutorials";
export const Latestarticles = "Latest articles and videos";
export const Knowledgebases = "Knowledgebase";
export const BrowseArticles = "Browse Articles";
export const knowledgearticl = "knowledge articles by category";
export const SupportTickets = "Support Ticket";
export const Loss = "Loss";
export const DeleteData = "Delete Selected Data..!";
export const CardViewHeading = "Card View";
export const JobSearch = "Job Search";
export const JobFilterData = "Job Filter";
export const JobApplyHeading = "Job Apply";
export const JobListHeading = "Job List";
export const JobDetailHeading = "Job Details";
export const LearningListHeading = "Learning List";
export const Learning = "Learning";
export const NewProjectHeading = "New Project";
export const CreateNewProject = "Create New Project";
export const FilterHeading = "Filter";
export const FindJobs = "Find jobs";
export const Fulltime = "Full-time";
export const Contract = "Contract";
export const Parttime = "Part-time";
export const Internship = "Internship";
export const Temporary = "Temporary";
export const Commission = "Commission";
export const LocationHeading = "Location";
export const AllLocations = "All Locations";
export const NewYork = "New York";
export const SanFrancisco = "San Francisco";
export const Washington = "Washington";
export const Seattle = "Seattle";
export const Chicago = "Chicago";
export const AllJobTitle = "All Job Title";
export const JobHeading = "Job";
export const UIUxdesigner = "UI/Ux designer";
export const FindCourse = "Find Course";
export const Categories = "Categories";
export const Accounting = "Accounting";
export const GraphicDesigner = "Graphic designer";
export const Frontenddesigner = "Front end designer";
export const PHPdeveloper = "PHP developer";
export const ReactDeveloper = "React Developer";
export const IndustryHeading = "Industry";
export const AllIndustries = "All Industries";
export const ComputerSoftware = "Computer Software";
export const ITEngineer = "IT Engineer";
export const Serviceindustry = "Service industry";
export const FinancialServices = "Financial Services";
export const Htmlcss = "HTML,scss & sass";
export const Javascript = "Javascript";
export const Nodejs = "Node.js";
export const SpecificSkills = "Specific skills";
export const AllSkills = "All Skills";
export const GulpPug = "Gulp & Pug";
export const Angularjs = "Angular.js";
export const UIDesigner = "UI Designer";
export const Savethisjob = " Save this job";
export const PersonalDetails = "Personal Details";
export const RepeatPassword = "Repeat Password";
export const BirthDate = "Birth Date";
export const CollegeName = "College Name";
export const Period = "Period";
export const DegreeLevel = "Degree Level";
export const Specialization = "Specialization";
export const YourExperience = "Your Experience";
export const YourEducation = "Your Education";
export const UploadCoverLetter = "Upload Cover Letter";
export const UploadYourCV = "Upload Your CV";
export const UploadRecommendations = "Upload Recommendations";
export const UploadYourFiles = "Upload Your Files";
export const CompanyName = "Company Name";
export const ProductDesigner = "Product Designer (UI/UX Designer)";
export const EndlessUnitedStates = "Endless - United States";
export const JobDescription = "Job Description";
export const Share = "Share";
export const Similarjobs = "Similar jobs";
export const BlogHeading = "Blog";
export const Filter = "Filter";
export const Design = "Design";
export const Development = "Development";
export const Management = "Management";
export const Duration = "Duration";
export const AllCourses = "All Courses";
export const PaidCourses = "Paid Courses";
export const FreeCourses = "Free Courses";
export const Registration = "Registration";
export const Completed = "Completed";
export const UIDesign = "UI Design";
export const InterfaceDesign = "Interface Design";
export const UserExperience = "User Experience";
export const UXDesign = "UX Design";
export const FrontendDevelopment = "Frontend Development";
export const BackendDevelopment = "Backend Development";
export const UpcomingCoursesHeading = "Upcoming Courses";
export const UXDevelopment = "UX Development";
export const BusinessAnalyst = "Business Analyst";
export const WebDevelopment = "Web Development";
export const DetailedCourses = "Detailed Course";
export const GoogleMaps = "Google Maps";
export const Polylines = "Polylines";
export const LeafletMap = "Leaflet Maps";

// Editors
export const CkEditors = "Ck Editor";
export const Editor = "Editor";
export const AceEditors = "Ace Editor";
export const InlineEditor = "Inline Editor";
export const MDEEditors = "MDE Editor";
export const FirstExamples = "First Example";
export const Discard = "Discard";
// Ecommerce
export const ProductPages = "Product Page";
export const WomenPinkshirt = "Women Pink shirt.";
export const ShareIt = "share it";
export const RateNow = "Rate Now";
export const AddToCart = "Add To Cart";
export const BuyNow = "Buy Now";
export const AddToWishList = "Add To WishList";
export const Brand = "Brand";
export const ProductLists = "Product List";
export const ProductListHeading = "Individual Column Searching (Text Inputs)";
export const PaymentDetailsHeading = "Payment Details";
export const Creditcards = "Credit Card";
export const Debitcard = "Debit Card";
export const ExpirationDate = "Expiration Date";
export const COD = "COD";
export const EMI = "EMI";
export const NetBankingTitle = "Net Banking";
export const Products = "Product";
export const Filters = "Filters";
export const ProductDetails = "Product Details";
export const AddToCartity = "Add to Cart";
export const ViewDetails = "View Details";
export const Categorys = "Categorys";
export const Colors = "Colors";
export const Apply = "Apply";
export const TotalPrice = "Total Price";
export const ContinueShopping = "Continue Shopping";
export const CartEmpty = "Cart Empty";
export const Checkouts = "Checkout";
export const BillingDetails = "Billing Details";
export const TownCity = "Town/City";
export const StateCountry = "State/Country";
export const CheckPayments = "Check Payments";
export const CashOnDelivery = "Cash On Delivery";
export const PlaceOrder = "Place Order";
export const Subtotal = "Subtotal";
export const Shipping = "Shipping";
export const RecentOrders = "Recent Orders";
export const OrdersHistory = "Orders History";
export const NewOrder = "New Orders";
export const ShippedOrders = "Shipped Orders";
export const CancelledOrders = "Cancelled Orders";
export const Datatableorderhistory = "Datatable order history";
export const Wishlists = "Wishlist";
export const BeComeMember = "Become member";
export const SimplePricingCards = "Simple Pricing Card";

// charts
export const ApexChartHeading = "Apex Chart";
export const BasicAreaChart = "Basic Area Chart";
export const AreaSpalineChart = "Area Spaline Chart";
export const BarChart = "Bar chart";
export const ColumnChart = "Column Chart";
export const BubbleChart = "3d Bubble Chart";
export const SteplineChart = "Stepline Chart";
export const PieChart = "Pie Chart ";
export const DonutChart = "Donut Chart";
export const MixedChart = "Mixed Chart";
export const CandlestickChart = "Candlestick Chart";
export const RadarChart = "Radar Chart";
export const RadialBarChart = "Radial Bar Chart";
export const AreaChart = "Area Chart";
export const BarChart2 = "bar-chart2";
export const BasicBarChart = "Basic bar Chart";
export const GoogleChartHeading = "Google Chart";
export const StackingAreaChart = "Stacking Area Chart";
export const RotatingPieChart = "Rotating A Pie Chart";
export const LineChart2 = "Line Chart-2 Chart";
export const DoughnutChart = "Doughnut Chart";
export const PolarChart = "Polar Chart";
export const BackToHomePage = "BACK TO HOME PAGE";
export const WeAreComingSoon = "WE ARE COMING SOON";
export const CurrentLocation = "Current Location";
export const MarkerMap = "Marker Map";
export const Polygons = "POLYGONS";
export const SliceVisibilityThreshold = "Slice Visibility Threshold";
export const MaterialDesign = "Material Design";
export const ComboChart = "ComboChart";
export const GanttChart = "Gantt Chart";
export const LineChart = "Line Chart";
// Project
export const ProjectListHeading = "Project List";
export const CreateNewProjects = "Create New Project";

export const All = "All";
export const Doing = "Doing";
export const Done = "Done";
export const Issues = "Issues";
export const Resolved = "Resolved";
export const Comment = "Comment";
export const ProjectCreates = "Project Create";
export const Add = "Add";
export const ProjectTitle = "Project Title";
export const ClientName = "Client name";
export const ProjectRate = "Project Rate";
export const ProgressLevel = "Progress Level";
export const ProjectStatus = "Project Status";
export const ProjectSize = "Project Size";
export const Medium = "Medium";
export const Big = "Big";
export const StartingDate = "Starting date";
export const EnterSomeDetails = "Enter some Details";
export const UploadProjectFile = "Upload project file";
export const Apps = "Apps";
export const FileManagerHeading = "File Manager";
export const FileFilter = "File filter";
export const AddNew = "Add New";
export const AllFiles = "All Files";
export const File = "Files";
export const Storage = "Storage";
export const PricingPlan = "Pricing Plan";
export const Selected = "Selected";
export const TrialVersion = "Trial Version";
export const FREE = "FREE";
export const Premium = "Premium";
export const QuickAccess = "Quick Access";
export const Folder = "Folders";

// SerachResult
export const SearchWebsite = `Search Website`;
export const SearchPages = `Search Pages`;
export const Search = "Search";
export const Images = "Images";
export const Videos = "Videos";
export const Maps = "Maps";
export const SearchPixelStrap = `Search result for "Pixelstrap"`;
export const MyPortfolioTitle = "My Portfolio";
export const ToDoHeading = "To-Do";
export const ToDofilter = "To Do filter";
export const ToDoList = "To Do List";
export const AddTask = "Add Task";
export const SocialAppHeading = "Social App";
export const MyPage = "My Page";
export const Likes = "Likes";
export const View = "View";
export const NewLikesThisWeek = "New Likes This Week";
export const MyProfile = "My Profile";
export const MutualFriend = "Mutual Friends";
export const ActivityFeed = "Activity Feed";
export const Photo = "Photo";
export const MoreComments = "More Comments";
export const ProfileIntro = "Profile Intro";
export const AboutMe = "About Me";
export const FavouriteTVShows = "Favourite TV shows";
export const FavouriteMusicBands = "Favourite Music Bands ";
export const SocialNetworks = "Social Networks";
export const Facebook = "Facebook";
export const Dribbble = "Dribbble";
export const Followers = "Followers";
export const AddFriend = "Add Friend";
export const LatestPhoto = "Latest Photos";
export const Friends = "Friends";
export const PepoleKnow = "Pepole You May Know";
export const HobbiesAndInterest = "Hobbies and Interests";
export const Hobbies = "Hobbies";
export const FavouriteMusicBandsArtists = "Favourite Music Bands / Artists";
export const FavouriteBooks = "Favourite Books";
export const FavouriteGames = "Favourite Games:";
export const FavouriteMovies = "Favourite Movies";
export const FavouriteWriters = "Favourite Writers:";
export const OtherInterests = "Other Interests:";
export const EducationAndEmploymentHeading = "Education and Employement";
export const TheNewCollegeOfDesign = "The New College of Design";
export const DigitalDesignIntern = "Digital Design Intern";
export const RembrandtInstitute = "Rembrandt Institute";
export const UXUIDesigner = "UI/UX Designer";
export const TheDigitalCollege = "The Digital College";
export const ViewedYourProfile = "Viewed Your Profile";
export const ActivityLogHeading = "Activity Log";
export const Posts = "Posts";

// Calender
export const CalenderHeading = "Calender Basic";
export const DraggableEvents = "Draggable Events";
export const RemoveAfterDrop = "remove after drop";

// Tasks
export const TasksHeading = "Tasks";
export const TaskFilter = "task filter";
export const Views = "Views";
export const Newsletter = "News letter";
export const Holidays = "Holidays";
export const Business = "Business";
export const Tags = "Tags";
export const Save = "Save";
export const CreatedByMe = "Created By Me";
export const TodayTasks = "Today's Tasks";
export const DelayedTasks = "Delayed Tasks";
export const UpcomingTasks = "Upcoming Tasks";
export const ThisWeekTask = "This week tasks";
export const AssignedToMe = "Assigned to me";
export const MyTasks = "My tasks";
export const ThisMonthTasks = "This month tasks";
export const NoTaskDueToday = "No task due today.";
export const NoTasksFound = "No tasks found.";
export const NewTask = "New Task";
export const AddNewTask = "Add New Task";
export const TaskTitle = "Task Title";
export const Collection = "Collection";
export const Print = "Print";
export const UserProfiles = "User Profile";
export const Users = "Users";
export const Designer = "Designer";
export const UpdateProfile = "UpdateProfile";
export const PostalCode = "Postal Code";
export const Germany = "Germany";
export const EditProfile = "Edit Profile";
export const UserEdits = "User Edit";
export const AddprojectAndUpload = "Add project And Upload";
export const ProjectName = "Project Name";
export const Edit = "Edit";
export const Update = "Update";
export const UserCards = "User Cards";

// Email
export const Emails = "Email";
export const EmailApps = "Email App";
export const NewMail = "NEW MAIL";
export const AllMail = "All mail";
export const Sent = "Sent";
export const Draft = "Draft";
export const Trash = "Trash";
export const TrashList = "Trash List";
export const IMPORTANT = "IMPORTANT";
export const Starred = "Starred";
export const UNREAD = "UNREAD";
export const Spam = "Spam";
export const OUTBOX = "OUTBOX";
export const UPDATE = "UPDATE";
export const ALERT = "ALERT";
export const NOTES = "NOTES";
export const More = "More";
export const DownloadAll = "Download All";
export const ATTACHMENTS = "ATTACHMENTS";
export const Reply = "Reply";
export const ReplyAll = "Reply All";
export const Forward = "Forward";
export const EmailComposes = "Email Compose";
export const NewMessage = "New Message";
export const To = "To";
export const Subject = "Subject";
export const Send = "Send";

// Chat
export const VideoChats = "Video Chat";
export const Chat = "Chat";
export const EndCall = " End Call";
export const Active = "Active";
export const Fax = "Fax";
export const ChatApp = "Chat App";

// Bookmark
export const BookmarkFilter = "Bookmark Filter";
export const Favourites = "Favourites";
export const SharedWithMe = "Shared with me";
export const Important = "Important";
export const AddBookmark = "Add Bookmark";
export const EditBookmark = "Edit Bookmark";
export const MyBookmark = " My bookmark";
export const Orgenization = "Organization";
export const NewBookmark = "New Bookmark";
export const WebUrl = "Web Url";
export const Group = "Group";
export const Title = "Title";
export const CreateTag = "Create Tag";
export const TagName = "Tag Name";
export const TagColor = "Tag Color";
export const NoBookmarksFound = "No Bookmarks Found.";

// Contact
export const Contacts = "Contacts";
export const ContactFilter = "Contact Filter";
export const FollowUp = "Follow Up";
export const Ideas = "Ideas";
export const NewContacts = "New Contacts";
export const AddContacts = "Add Contacts";
export const Mobile = "Mobile";
export const Personal = "Personal";
export const AddCategory = "Add Category";
export const History = "History";
export const MobileNo = "Mobile No";
export const PrintViews = "Print Views";
export const Organization = "Organization";
export const Gender = "Gender";
export const ContactHistory = "Contact History";
export const ContactCreated = "Contact Created";
// Tables
export const ReactstrapBasicTables = "Reactstrap Basic Tables";
export const ReactstrapTables = "Reactstrap Tables";
export const BasicTableWithBorderBottomColor =
  "Basic Table With Border Bottom Color";
export const InverseTable = "Inverse Table";
export const HoverableRowsWithHorizontalBorder = `Hoverable Rows With Horizontal Border`;
export const CaptionSpan = [
  {
    text: `A <caption> functions like a heading for a table. It helps users with screen readers to find a table and understand what it’s about and decide if they want to read it.`,
  },
];
export const StripedRowWithInverseTable = `Striped Row with Inverse Table`;
export const SizeTable = `sizing Table`;
export const CustomTable = `Custom Table Color With Hover And Stripped`;
export const Id = "Id";
export const JoinDate = "Join Date";
export const Office = "Office";
export const Age = "Age";
export const Position = "Position";
export const Salary = "Salary";
export const Schedule = "Salary";
export const Security = "Salary";
export const Status = "Salary";
export const TeamLead = "Salary";
export const SignalName = "Salary";
export const Stage = "Salary";
export const Budget = "Budget";
export const Sex = "Sex";
export const EmployeeName = "Employee Name";
export const Experience = "Experience";
export const Calories = "Calories";
export const Quantity = "Quantity";
export const OrderId = "OrderId";
export const Assign = "Assign";
export const Phone = "Phone";
export const Hours = "Hours";
export const Performance = "Performance";
export const DomesticGross = "DomesticGross";
export const FilmTitle = "FilmTitle";
export const Released = "Released";
export const Studio = "Studio";
export const Spots = "Spots";
export const Trainer = "Trainer";
export const Type = "Type";
export const ClassNames = "ClassName";
export const Designation = "Designation";
export const Company = "Company";
export const Language = "Language";
export const InverseTablePrimaryBackground = "Inverse Table Primary Background";
export const Role = "Role";
export const CreditVolume = "Credit Volume";
export const Caption = "Caption";
export const TableHeadOptions = "Table Head Options";
export const DessertType = "Dessert Type";
export const Fat = "Fat";
export const Dessert = "Dessert";
export const Weigth = "Weigth";
export const BreckPointSpecific = "Breck Point Specific";
export const DashedBorder = "Dashed Border";
export const Total = "Total";
export const ResponsiveTables = "Responsive Tables With Light Background";
export const Task = "Task";
export const TableComponents = "Table Components";
export const UIComponents = "UI Components";
export const ProgressBarHeading = "Progress Bar";
export const Checkbox = "Checkbox";
export const RadioButtons = "Radio Buttons";
export const Select = "Select";
export const Input = "Input";
export const TooltipTriggers = "Tooltip Triggers";
export const Badges = "Badges";
export const Switch = "Switch";
export const DefaultButton = "Default Button";
export const Buttondropdowns = "Button dropdowns";
export const BasicButtongroup = "Basic Button group";
export const ButtonswithIcon = "Buttons with Icon";
export const IconButton = "Icon Button";
export const LoadingButtons = "Loading Buttons";
export const BasicAlert = "Basic Alert";
export const AlertswithLinks = "Alerts with Links";
export const DismissibleAlerts = "Dismissible Alerts";
export const Alertswithicons = "Alerts with icons";
export const DefaultProgress = "Default Progress";
export const StripedProgress = "Striped Progress";
export const ProgressSizes = "Progress Sizes";
export const Checkboxs = "Checkbox";
export const BasicCheckboxs = "Basic Checkbox";
export const DefaultCheckboxSquar = "Default Checkbox Squar";
export const BasicSkinCheck = "Basic Skin Check";
export const DisableCheck = "Disable Check";
export const FlatSkinCheck = "Flat Skin Check";
export const InlineCheckboxs = "Inline  Checkbox";
export const RadioButton = "Radio Button";
export const BasicRadioButton = "Basic Radio Buttons";
export const CheckedRadio = "Checked Radio";
export const Selects = "Select";
export const SingleSelect = "Single Select";
export const DisabledSelectMode = "Disabled Select Mode";
export const LargeSelectModes = "Large Select Mode";
export const Examplemultipleselect = "Example multiple select";
export const DefaultInputtext = "Default Input text";
export const TooltipTrigger = "Tooltip Triggers";
export const Outlinebutton = "outline button";
export const Switchs = "Switch";
export const DefaultSwitch = "Default Switch";
export const UnheckedSwitch = "Unhecked Switch";
export const DisableSwitch = "Disable Switch";
export const SwitchOutline = "Switch Outline";
export const SwitchColor = "Switch Color";
export const BasicInitHeading = "Basic Init";
export const DataTables = "Data Tables";
export const ZeroConfigurationHeading = "Zero Configuration";
export const StateSaving = `State saving`;
export const DynamicHeight = `Scroll - vertical, dynamic height`;
export const AdvanceInitHeading = "Advance Init";
export const StockResult = `Stock Result`;
export const RowCreateCallBackHeading = "Row Create Callback";
export const APIDataTable = "API DataTables";
export const AddRowsHeading = "Add rows";
export const AddNewRow = "Add new row";
export const ChildrenRows = "Child rows (show extra / detailed information)";
export const FullName = "Full name";
export const ExtraInfo = "Extra info";
export const RowsSelectionAndDeletion =
  "Row Selection And Deletion (Single Row)";
export const DeleteRow = "Delete Row";
export const CustomFilteringSearch = "Custom filtering - range search";
export const MinimumAge = "Minimum age:";
export const MaximumAge = "Maximum age:";
export const DATASourceDataTables = "DATA Source DataTables";
export const HtmlTableTittle = "HTML (DOM) sourced data";
export const AjaxSourcedDataHeading = "Ajax sourced data";
export const JavascriptSourcedDataHeading = "Javascript sourced data";
export const ServerSideProcessingHeading = "Server-side processing";

// Forms
export const FormWizards = "Form Wizard";
export const FormLayouts = "Form Layout";
export const NumberingWizardHeading = "Numbering wizard";
export const Congratulations = "Congratulations ";
export const CongratulationsMessage =
  "Well done! You have successfully completed. ";
export const AboveInformationCorrect = "All the above information is correct";
export const ConfirmPassword = "Confirm Password";
export const AgreeToTermsAndConditions = "Agree to terms and conditions";
export const Expiration = "Expiration(MM/YY)";
export const CVVNumber = "CVV Number";
export const UploadDocumentation = "Upload Documentation";
export const LinkedIn = "LinkedIn";
export const Github = "Git hub";
export const SelectState = "Select State";
export const GiveFeedback = "Give Feedback";
export const CardHolder = "Card Holder";
export const StudentValidationFormHeading = "Student validation form";
export const ProductDetail = "Product Detail";
export const CurrentCartHeading = "Current Cart";
export const verticalValidationWizardHeading = "Vertical validation wizard";
export const AddProfile = "Add Profile";
export const CreditCard = "Credit Card";
export const ShippingFormHeading = "Shipping form";
export const BillingInformation = "Billing Information ";
export const OrderID = "Order ID";
export const FillFollowingInformation = "Fill up the following information ";
export const OrderConfirmed = "Thank you! Your order is confirmed.";
export const OrderConfirmedDetails =
  "An email with your orders specifics will be sent to you as order confirmation.";
export const BalanceText = "Example of cuba dashboard balance card.";
export const TextModal = "Example of cuba dashboard profile card.";
export const SocialLinks = " Social Links ";
export const Twitter = " Twitter";
export const Previous = " Previous";
export const Next = " Next";
export const NetBanking = " NET BANKING";
export const City = "City";
export const SelectYourBank = " SELECT YOUR BANK";
export const Finish = "Finish";
export const OtpCode = "Your OTP Code here:";
export const ZipCode = "Zip Code";
export const ValidationForms = "Validation Form";
export const FormsControls = "Form Controls";
export const TooltipFormValidationHeading = "Tooltip Form Validation";
export const LastName = "Last name";
export const SubmitForm = "Submit form";
export const StateError = "Please select a valid state.";
export const CityError = "Please provide a valid city.";
export const Zip = "Zip";
export const State = "State";
export const UserName = "Username";
export const Hometxt = "Home";
export const FormControl = "FormControl";
export const ZipError = "Please provide a valid zip.";
export const cityError = "Please provide a valid city.";
export const ValidFeedBack = "Looks good!";
export const TermsAndConditions = "Agree to terms and conditions";
export const CheckThisCheckbox = "Check this checkbox";
export const InvalidFeedBack = "Example invalid feedback text";
export const ToggleThisRadio = "Toggle this radio";
export const OrToggleThisRadio = "Or toggle this other radio";
export const MoreInvalidFeedBack = "More example invalid feedback text";
export const SelectMenu = "Open this select menu";
export const InvalidFile = "Example invalid form file feedback";
export const One = "One";
export const Two = "Two";
export const Three = "Three";
export const FirstNameRequire = "First name is required";
export const Website = "Website";
export const UserNameError = "Please choose a unique and valid username.";
export const BrowserDefaultsHeading = "Browser defaults";
export const EmailAddress = "Email Address";
export const ChooseFile = "Choose file";
export const Visa = "Visa";
export const MasterCard = "MasterCard";
export const PayPal = "Paypal";
export const AgreePolicies = "I agree to the policies";
export const InformationConfirm = "Are you sure above information are true";
export const SelectYourPaymentMethod = "Select your payment method";
export const ValidationFormHeading = "Validation Form";
export const NameError = "Please enter your valid Name";
export const PasswordError = "Please enter your valid password";
export const MaterCard = "MaterCard";
export const FavoritePixelStrapTheme = "Select Your Favorite Pixelstrap theme";
export const InvalidSelectFeedBack = "Invalid select feedback";
export const InvalidFormFileSelected = "Invalid form file selected";
export const InvalidMessageError = "Please enter a message in the textarea.";
export const AgreeConditions = "Agree to terms and conditions";
export const AgreeFeedback = "You must agree before submitting.";
export const BaseInputs = "Base Inputs";
export const BasicFormHeading = "Basic form";
export const Upgrade = "Upgrade";
export const FloatingFormHeading = "Floating Form";
export const SelectSizingHeading = "Select Sizing";
export const CheckMeOut = "Check me out";
export const SignIn = "Sign in";
export const FormControlSizingHeading = "Form Control Sizing";
export const FileInputHeading = "File Input";
export const DefaultExample = "Default file input example";
export const MultipleExample = "Multiple files input example";
export const DisabledExample = "Disabled file input example";
export const SmallFileInputExample = "Small file input example";
export const LargeFileInputExample = "Large file input example";
export const FlatInputStyleHeading = "Flat Input Style";
export const MultiplePaintingsLabel = "Select your multiple paintings";
export const PleaseDoComments = "Please do comments";
export const BasicHTMLInputControlHeading = "Basic HTML Input Control";
export const PlaceHolderHeading = "Placeholder ";
export const ColorPickerHeading = "Color picker";
export const DataListExampleHeading = "Datalist example";
export const DateHeading = "Date";
export const DateAndTimeHeading = "Date and time";
export const CommentsHeading = "Comments";
export const URLHeading = "URL";
export const MaximumLengthHeading = "Maximum Length";
export const MonthHeading = "Month";
export const NumberHeading = "Number";
export const PasswordHeading = "Password";
export const TelephoneHeading = "Telephone";
export const TimeHeading = "Time";
export const OpenThisSelectMenu = "Open This Select Menu";
export const WeekHeading = "Week";
export const LayoutHeading = "Layout";
export const EmailHeading = "Email";
export const InputGroupHeading = "Input group";
export const BasicFloatingInputControlHeading = "Basic floating input control";
export const ValidInputHeading = "Valid Input";
export const InputWithValue = "Input with value";
export const EdgesInputStyleHeading = "Edges input style";
export const FileInputExample = "Default file input example";
export const DefaultInput = "Default Input";
export const Male = "Male";
export const Female = "Female";
export const Comments = "Comments";
export const RaiseInputStyleHeading = "Raise input style";
export const SelectTheColorHeading = "Select the color you like below";
export const DefaultCheckBoxHeading = "Default CheckBox";
export const DefaultChecksHeading = "Default Checks";
export const DefaultCheckBox = "Default checkbox";
export const CheckedCheckBox = "Checked checkbox";
export const InvalidInputHeading = "Invalid input";
export const WorksWithSelects = "Works with selects";
export const RadioCheckBoxHeading = "Checkbox & Radio";
export const InputGroupsHeading = "Input Groups";
export const MegaOptionHeading = "Mega Option";
export const DatePickerHeading = "Date Picker";
export const FormControlsHeading = "Forms Controls";
export const InputMasksHeading = "Input Masks";
export const FormWizardHeading = "Form Wizard";
export const FormWizard2Heading = "Form Wizard 2";
export const FormLayoutHeading = "Form Layout";
export const TwoFactorHeading = "Two Factor";
export const ClipBoardHeading = "Clip Board";
export const FormWidgetsHeading = "Form Widgets";
export const TouchSpinHeading = "Touch Spin";
export const DateTimePickerHeading = "Date Time Picker";
export const Select2Heading = "Select 2";
export const SwitchHeading = "Switch";
export const TimePickerHeading = "Time Picker";
export const LeafletWorldMap = "Leaflet WORLD MAP";
export const DisabledChecksHeading = "Disabled Checks";
export const DisabledCheckBox = "Disabled checkbox";
export const InlineInputTypesHeading = "Inline input-types";
export const InlineCheckBoxHeading = "Inline Checkbox";
export const InlineRadiosBoxHeading = "Inline Radios";
export const InlineSwitchesHeading = "Inline Switches";
export const AnimatedButtonsHeading = "Animated buttons";
export const SelectPaymentMethod = "Select your payment method";
export const YourFavoriteSocialMedia = "What is your favorite social media? ";
export const BasicRadioAndCheckBox = "Basic radio and checkbox";
export const SimpleCheckBox = "Simple Checkbox";
export const SimpleRadiosHeading = "Simple Radios";
export const RadioToggleButtonsHeading = "Radio toggle buttons";
export const PaymentMethod = "Payment Method";
export const Address = "Address";
export const Country = "Country";
export const Remembermefornexttime = "Remember me for next time";
export const OtherNotes = "Other Notes";
export const ProceedtoNext = "Proceed to Next";
export const ShippingMethod = "Shipping Method";
export const ShippingInformation = "Shipping Information";
export const SavedAddress = "Saved Address";
export const ShippingInformationText =
  " Fill up the following information to send you the order";
export const Information = "Information";
export const AddressType = "Address Type";
export const ContactNo = "Contact No";
export const PaymentInformation = "Payment Information";
export const PaymentInformationText =
  "Fill up the following information to send you the order";
export const CashOnDeliveryHeading = "Cash On Delivery";
export const PortfolioURL = "Portfolio URL";
export const ProjectDescription = "Project Description";
export const TwoFactors = "Two Factor";
export const TwoFactorAuthenticationHeading = "Two-factor authentication";
export const FactorAuthentication = "2 factor authentication";
export const ScanQRcode = "Scan QR code";
export const EmailVerificationHeading = "Email Verification";
export const VerificationCodeHeading = "Verification Code";
export const Resend = "Resend";
export const Call = "Call";
export const NotReceivedCode = "Not Received your Code?";
export const Continue = "Continue";
export const AadhaarNumber = "Aadhaar Number";
export const PAN = "PAN";
export const ChooseBanks = "Choose from these popular banks";
export const SuccessfullyCompleted = "Successfully Completed";
export const Customhorizontalwizard = "Custom horizontal wizard";
export const Businessverticalwizard = "Business vertical wizard";
export const AccountType = "Select the type of account";
export const SearchYour = "Search your";
export const AccountName = "Account Name";
export const SelectTeamWith = "Select team size with";
export const Projects = "projects";
export const ContactDetails = "Contact details";
export const OrganizationName = "Organization Name";
export const JoinOrganizationType = "Join organization type";
export const OrganizationDescription = "Organization description";
export const Customverticalwizard = "Custom vertical wizard";
export const Businesshorizontalwizard = "Business horizontal wizard";
export const DisabledCheckedCheckBox = `Disabled Checked CheckBox`;
export const RightChecks = `Right Checks`;
export const IndeterminateCheckBox = `Indeterminate CheckBox`;
export const IndeterminateHeading = `Indeterminate`;
export const CustomCheckBoxHeading = `Custom CheckBox`;
export const BorderedCheckBoxHeading = `Bordered CheckBox`;
export const DisabledReverseCheckBox = `Disabled Reverse CheckBox`;
export const ReverseCheckBox = `Reverse CheckBox`;
export const IconCheckBoxHeading = `Icon CheckBox`;
export const FilledCheckBoxHeading = `Filled Checkbox`;
export const DefaultRadioHeading = `Default Radio`;
export const CustomRadiosHeading = "Custom Radios";
export const DefaultCheckedRadio = "Default Checked Radio";
export const DefaultRadio = "Default Radio";
export const DisabledCheckedRadio = "Disabled Checked Radio";
export const DisabledRadio = "Disabled Radio";
export const DisabledRadiosHeading = "Disabled Radios";
export const RightRadiosHeading = "Right Radios";
export const ImagesWithCheckBoxHeading = "Images With CheckBox";
export const ImagesWithRadioBoxHeading = "Images With RadioBox";
export const CustomRadioBoxHeading = "Custom RadioBox";
export const DefaultSwitchesBoxHeading = "Default Switches Box";
export const CheckedSwitchCheckboxInput = "CheckedSwitch Checkbox Input";
export const CustomSwitches = "Custom Switches";
export const DefaultSwitchCheckboxInput = "Default Switch CheckboxInput";
export const DisabledCheckedSwitchCheckboxInput =
  "Disabled Checked Switch Checkbox Input";
export const DisabledSwitchCheckboxInput = "Disabled Switch CheckboxInput";
export const DisabledSwitches = "Disabled Switches";
export const BorderedRadioBoxHeading = "Bordered Radio";
export const IconRadioBoxHeading = "Icon Radio";
export const FilledRadioBoxHeading = "Filled Radio";
export const RightSwitchesHeading = "Right Switches";
export const Reverseswitchcheckboxinput = "Reverse switch checkbox input";
export const Disabledswitchcheckboxinput = "Disabled switch checkbox input";
export const OutlinedCheckBoxStylesHeading = "Outlined CheckBox Styles";
export const ButtonAddonsHeading = "Button Addons";
export const CustomFormsHeading = "Custom Forms";
export const CustomFileInputHeading = "Custom File Input";
export const Upload = "Upload";
export const Verify = "Verify";
export const ButtonsWithDropDownsHeading = "Buttons With DropDowns";
export const DropdownHeading = "Dropdown";
export const CheckboxesAndRadiosHeading = "Checkboxes and radios";
export const Info = "Info";
export const Secondary = "Secondary";
export const SizingHeader = "Sizing";
export const Small = "Small";
export const Large = "Large";
export const FirstAndLastName = "First and last name";
export const DollarSign = "$";
export const ZeroAmount = "0.00";
export const BasicInputGroupsHeading = "Basic input groups";
export const VariationOfAddonsHeading = "Variation of addons";
export const RecipientUserName = "@example.com";
export const BasicHeader = "Basic";
export const WithTextArea = "With textarea";
export const WrappingHeading = "Wrapping";
export const SegmentedButtonsHeading = "Segmented Buttons";
export const ToggleDropdown = "Toggle Dropdown";
export const MultipleInputsHeading = "Multiple Inputs";
export const LeftAddon = `Left Addon`;
export const RightAddon = `Right Addon`;
export const JointAddon = `Joint Addon`;
export const LeftAndRightAddon = `Left & Right Addon`;
export const SolidStyle = `Solid style`;
export const FlatStyle = `Flat style`;
export const RaiseStyle = `Raise style`;
export const DefaultStyleHeading = `Default style`;
export const EdgeButtons = `Edge Buttons`;
export const RaisedButtons = `Raised Buttons`;
export const FlatStyleHeading = `Flat style`;
export const InputMasks = "Input Mask";
export const DefaultInputMask = "Default Input Mask";
export const Currency = "Currency";
export const Prefix = "Prefix";
export const Delimiter = "Delimiter";
export const PhoneNumber = "Phone Number";
export const CardNumber = "Card Number";
export const Tailprefix = "Tail prefix";
export const DateFormatHeading = "Date Format";
export const Date = "Date";
export const DateFormatType = "Date format type";
export const TimeFormatHeading = "Time Format";
export const TimeFormatType = "Time format type";
export const HourMonthType = "Hour/month type";
export const MegaOption = "Mega Options";
export const VariationRadioHeading = `Variation radio`;
export const MostImportantThingsToLearnAboutWebDesign =
  "What are the most important things to learn about web design?";
export const RadiosWithCreativeOptionsSVGIcons =
  "Radios With Creative Options & SVG Icons";
export const WhichActivitiesDoYouEnjoy =
  "Which of the following activities do you enjoy doing in your free time?";
export const VariationCheckBoxHeading = "Variation checkbox ";
export const ItIsTimeTo = "It's time to";
export const Sales = " Sales";
export const INR = "INR";
export const WithoutBordersStyleHeading = "Without Borders Style";
export const SolidBorderStyleHeading = "Solid Border Style";
export const offerStyleBorderHeading = "offer Style Border";
export const InlineStyleHeading = "Inline Style";
export const VerticalStyleHeading = "Vertical Style";
export const DeliveryOptionHeading = "Delivery Option";
export const BuyingOptionHeading = "Buying Option";
export const StartRatingHeading = "start rating";
export const HorizontalStyleHeading = "Horizontal Style";
export const MovieRatingBar = "Movie Rating Bar";
export const SquareRatingBar = "Square Rating Bar";
export const PillRatingBar = "Pill Rating Bar";
export const HalfStarRatingBar = "Half Star Rating Bar";
export const HeartRatingBar = "Heart Rating Bar";

// form widgets
export const Datepickers = "Datepicker";
export const LeafletUkMap = "Leaflet UK MAP";
export const LeafletUSAMap = "Leaflet USA MAP";
export const LeafletIndiaMap = "Leaflet India MAP";
export const LeafletAustraliaMap = "Leaflet Australia MAP";
export const JavascriptModeHeading = "Javascript Mode";
export const HTMLModeHeading = "HTML Mode";
export const CSSModeHeading = "CSS Mode";
export const JavaModeHeading = "Java Mode";
export const DefaultCalendarHeading = "Default calendar";
export const ReactstrapCalendarHeading = "Reactstrap calendar";
export const Month = "Month";
export const Week = "Week";
export const Time = "Time";
export const DefaultDate = "Default Date";
export const HumanFriendly = "Human Friendly";
export const MinMaxValue = "Min-Max Value";
export const DisabledDates = "Disabled Dates";
export const MultiplesDatesHeading = "Multiples Dates";
export const Range = "Range";
export const PreloadingDates = "Preloading Dates";
export const hourPicker = "24-hour Time Picker";
export const TimePickerLimit = "Time Picker W/Limits";
export const PreloadingTimes = "Preloading Time";
export const CustomizingConjunctions = "Customizing Conjunction";
export const TimePickerRange = "TimePicker with Limited Time Range";
export const TimePickerMinMaxRanges = "TimePicker with Min/Max Time Range";
export const DateWithTimes = "Date With Time";
export const DefaultTouchSpinHeading = "Default Touchspin";
export const OutLinedTouchSpinHeading = "Outlined TouchSpin";
export const RoundedTouchSpinHeading = "Rounded TouchSpin";
export const IconsWithPrefixAndPostFixHeading = "Icons with prefix and postfix";
export const ButtonsWithPrefixAndPostFixHeading =
  "Buttons with prefix and postfix";
export const Pre = "Pre";
export const Post = "Post";
export const CustomSwitchHeading = "Custom switch";
export const IconsWithHeading = "Icons switch";
export const UncheckedSwitchHeading = "Unchecked switch";
export const BordersWithIconsHeading = "Borders With Icons";
export const MdeEditorExample = "MDE Editor Example";
export const MdeEditorText = `Enter text in the area on the left. For more info, click the ? (help) icon in the menu.`;
export const Instructions = "Instructions";
export const MNDeditortext =
  "Enter text in the area on the left. For more info, click the ? (help) icon in the menu.";
export const Profit = "Profit";
export const Delete = "Delete";
export const BasicDemo = "Basic Demo";
export const SwitchSizingHeading = "Switch Sizing";
export const SwitchWithIconsHeading = "Switch With Icons";
export const TypeAheadHeading = "Typahead";
export const BasicTypeAheadHeading = "Basic typeahead";
export const BloodHoundHeading = "Blood Hound";
export const CustomTemplate = "Custom templates";
export const MultipleSectionWithHeader = "Multiple sections with headers";
export const RemotetypeAheadHeading = "Remote typeahead";
export const PreFetchHeading = "Prefetch";
export const ScrollableDropDownMenus = "Scrollable DropDown Menu";
export const RTLSupports = "RTL Support";
export const Copy = "Copy";
export const ClipBoardOnTextInputHeading = "Clipboard on text input";
export const Cut = "Cut";
export const ClipBoardOnTextArea = "Clipboard on textarea";
export const CutCopyFromInputArea = "Cut/copy from text input";
export const CopyParagraph = "Copy portion from paragraph";
export const ClipboardOnTextAreaValue =
  "A web designer must always enhance their work since creating websites is a creative effort. Therefore, a web designer must be more imaginative to produce exceptional results. Blogs about web design assist web designers in learning about new technologies, offer lessons, news, direction for a freebie, and much more. These blogs allow web designers to stay creative and improve their abilities. Therefore, advice from web design blogs is required to improve your business.";
export const ClipboardOnParagraphHeading = "Clipboard on paragraph";
export const ClipboardOnParagraphValue =
  "On that day, hopes and dreams were crushed. Even though it should have been anticipated, it nonetheless surprised me. The warning indicators have been disregarded in favour of the slim chance that it would actually occur. From a hopeful prospect, it had evolved into an unquestionable conviction that it must be fate. That was up until it wasn't, at which point all of the aspirations and dreams collapsed.";
export const CopyTextParagraph =
  "that are visible online. Take a website design course to learn how to  create an appealing and responsive website. In the discipline of web design, there are degree, diploma, postgraduate degree, and certificate programmes. A web designer is responsible for a website's look, feel, and occasionally even content.";
export const CopyHighlighted = " Copy highlighted text";
export const DisabledOutlineSwitchHeading = "Disabled outline switch";
export const VariationOfSwitchesHeading = "Variation of switches";
export const Skewed = " Skewed";
// Buttons
export const DefaultStyles = "Default Style";
export const Buttons = "Button";
export const DefaultButtonsHeading = "Default Buttons";
export const LargeButtonsHeading = "Large Buttons";
export const SmallButtonsHeading = "Small Buttons";
export const ExtraSmallButtonsHeading = "Extra Small Buttons";
export const ActiveButtonsHeading = "Active Buttons";
export const DisabledButtonsHeading = "Disabled Buttons";
export const CustomStateButtonsHeading = "Custom State Buttons";
export const OutlineButtonsHeading = "Outline Buttons";
export const BoldBorderOutlineButtonsHeading = "Bold Border Outline Buttons";
export const OutlineLargeButtonsHeading = "Outline Large Buttons";
export const OutlineSmallButtonsHeading = "Outline Small Buttons";
export const OutlineExtraSmallButtonsHeading = "Outline Extra Small Buttons";
export const DisabledOutlineButtonsHeading = "Disabled Outline Buttons";
export const GradientButtonsHeading = "Gradient Buttons";
export const defaultButtonsHeadingData = "Bootstrap state buttons";
export const LargeButtonsHeadingData = `Add <code>.btn-lg</code> class for large size buttons`;
export const SmallButtonsHeadingData = `Add <code>.btn-sm</code> class for small size buttons`;
export const ExtraSmallButtonsHeadingData = `Add <code>.btn-xs</code> class for extra small size buttons`;
export const ActiveButtonsHeadingData = `Add <code>.active</code> class for active state`;
export const DisabledButtonsHeadingData = `Add <code>.disabled</code> class or <code>disabled="disabled"</code> attribute for disabled button`;
export const CustomStateButtonsHeadingData = `The <code>.btn</code> class used with <code>&lt;button&gt;</code>, <code>&lt;a&gt;</code> and <code>&lt;input&gt;</code> elements.`;
export const OutlineButtonsHeadingData = `Add <code>.btn-outline-*</code> class for border button`;
export const BoldBorderOutlineButtonsHeadingData = `Add <code>.btn-outline-*-2x</code> class for bold outline`;
export const OutlineLargeButtonsHeadingData = `Add <code>.btn-outline-*</code> class for outline and <code>.btn-lg</code> class for large button`;
export const OutlineSmallButtonsHeadingData = `Add <code>.btn-outline-*</code> class for outline and <code>.btn-sm</code> class for small button`;
export const OutlineExtraSmallButtonsHeadingData = `Add <code>.btn-outline-*</code> class for outline and <code>.btn-xs</code> class for extra small button`;
export const DisabledOutlineButtonsHeadingData = `Add <code>.disabled</code> class or <code>disabled="disabled"</code> attribute for disabled state`;
export const GraddienButtonsHeadingData = `Add <code>.btn-*-gradien</code> class for gradien button`;
export const Links = "Link";
export const CustomButtons = "Custom state buttons";
export const ButtonHeading = "Button";
export const CustomButtonsSpan = `The <code>.btn</code> class used with <code>&lt;button&gt;</code>, <code>&lt;a&gt;</code> and <code>&lt;input&gt;</code> elements.`;
export const NestingButtonSpan = `Make nesting buttons`;
export const Inputs = "Input";
export const Submit = "Submit";
export const FlatButton = "Flat Buttons";
export const EdgeButton = "Edge Buttons";
export const RaisedButton = "Raised Buttons";
export const ButtonGroups = "Button Group";
export const RadioButtonGroup = "Radio Button Group";
export const CheckBoxButtonGroup = "CheckBox Button Group";
export const Option1 = "Option 1";
export const Option2 = "Option 2";
export const Nesting = "Nesting";
export const Action = "Action";
export const AnotherAction = "Another Action";
export const Header = "Header";
export const Vertical = "Vertical";
// icons
export const FlagIcon = "Flag Icons";
export const Icons = "Icons";
export const Markup = "Markup";
export const CopyText = "Copy Text";
export const FontAwesomeIcon = "Font Awesome Icon";
export const ICOIcons = "ICO Icon";
export const ThemifyIcons = "Themify Icon";
export const FeatherIcon = "Feather Icon";
export const WhetherIcons = "Whether Icon";
export const WhetherIconsWithAnimations = "Whether Icons With Animations";
export const List = "Lists";
export const Contextualclasses = "Contextual classes";
export const Horizontallists = "Horizontal lists";
export const Customcontentlists = "Custom content lists";
export const Listswithcheckboxs = "Lists with checkbox";
export const AutoStart = "Auto Start";
export const Listswithradios = "Lists with radios";
export const Meditations = "Meditations";
export const Listswithnumbers = "Lists with numbers";
export const Numberedbadgelists = "Numbered & badge lists";
export const Disabledlists = "Disabled lists";
export const Scrollablelists = "Scrollable lists";
export const JavaScriptbehavior = "JavaScript behavior";
export const Product = "Product";
export const Productdetails = "Product details";
export const Pricing = "Pricing";
export const Paymentdetails = "Payment details";
export const Megaoptions = "Mega options";
export const YourBalances = "Your Balances";
export const Visitor = "Visitor";
export const TotalUser = "Total User";
export const FollowersGrowths = "Followers Growths";
export const Generals = "General";
export const Widgets = "Widgets";

// PageLayout
export const DarkFooter = "Dark Footer";
export const PageLayout = "Page Layout";
export const SampleCard = "Sample Card";
export const FixedFooter = "Fixed Footer";
export const OnScrollHideMenu = "Hide Menu On Scroll";

// Login
export const SignInAccount = "Sign in to account";
export const RememberPassword = "Remember password";
export const ForgotPassword = "Forgot password?";
export const SignInWith = "Or Sign In With";
export const FacebookHeading = "facebook";
export const TwitterHeading = "twitter";
export const LinkedInHeading = "LinkedIn";
export const DoNotAccount = "Don't have account?";
export const CreateAccount = "Create Account";
// ThemeCustomizer
export const CheckLayouts = "Check layouts";
export const Quickoption = "Quick option";
export const PREVIEWSETTINGS = "PREVIEW SETTINGS";
export const Layout_Type = "Layout Type";
export const Sidebar_Icon = "Sidebar Icon";
export const UnlimitedColor = "Unlimited Color";
export const Mix_Layout = "MixLayout";
export const Sidebar_Type = "Sidebar Type";
// Error
export const CreateYourAccount = "Create your account";
export const EnterYourPersonalDetails =
  "Enter your personal details to create account";
export const YourName = "Your Name";
export const PrivacyPolicy = "Privacy Policy";
export const AgreeWith = "Agree with";
export const SignUpWith = "Or signup with";
export const HaveAccount = "Already have an account?";
export const Unlock = "Unlock";
export const EnterYourPassword = "Enter your Password";
export const ResetYourPassword = "Reset Your Password";
export const EnterYourMobileNumber = "Enter Your Mobile Number";
export const SignUpToAccount = `Sign Up To Account`;
export const EmailPassWord = `Enter your email & password to login`;
export const HavePassport = "Have Passport";
export const Birthday = "Birthday";
export const RetypePassword = "Retype Password";
export const EnterOTP = "Enter OTP";
export const CreateYourPassword = "Create Your Password";
export const NewPassword = "New Password";
export const MAINTENANCE = `MAINTENANCE`;

// Setup

export const setup = "Setup";
export const createNewCity = "Create New City";
export const createNewCRMModule = "Create New CRM Module";
export const createNewPackage = "Create New Package";
export const createNewProvince = "Create New Province";
export const citiesList = "Cities List";
export const citiesListHeading = "All Cities";
export const provinceList = "Province List";
export const provinceListHeading = "All Provinces";
export const crMmoduleList = "CRM Module List";
export const crmModuleListHeading = "All CRM Modules";
export const packageList = "Package List";
export const packageListHeading = "All Packages";
export const vehicleModelList = "Vehicle Model List";
export const vehicleModelListHeading = "All Vehicles Model";

// List definitions
export const all = "All";
export const inactive = "Inactive";
export const active = "Active";

// Support
export const support = "Support";
export const loss = "Loss";
export const profit = "Profit";
